import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    let data = "";
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = text;
    }

    const token = response.headers.get("Authorization");
    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout(); // auto logout if 401 response returned from API
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// -------------------- Lab Service APIs --------------------
function getPackageTestnames(data, templateId) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/getPackageandTestNames?templateId=${templateId}`;
  return apiFetch(url, requestOptions);
}

function getTestnames(templateIds) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/getTestNames?templateId=${templateIds}`;
  return apiFetch(url, requestOptions);
}

function getCategoryByTemplateId(templateId) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/getCategoryByTemplateId?templateId=${templateId}`;
  return apiFetch(url, requestOptions);
}
function getFooterByTestName(testName) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/getFooterByTestName?testName=${encodeURIComponent(testName)}`;
  return apiFetch(url, requestOptions);
}

function updateApprover(data, username, id, docId) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/updateApprover?id=${id}&username=${username}&docId=${docId}`;
  return apiFetch(url, requestOptions);
}

function getPackageList() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/getPackageList`;
  return apiFetch(url, requestOptions);
}

function createLabPackage(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/createLabPackage`;
  return apiFetch(url, requestOptions);
}

function updatePackage(data, id) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/updatePackage?id=${id}`;
  return apiFetch(url, requestOptions);
}

async function getAllTestsInfo(testName, notes) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/getAllTestsInfo?testName=${testName}&notes=${notes}`;
  return apiFetch(url, requestOptions);
}

function updatePackageStatus(id) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/updatePackageStatus?id=${id}`;
  return apiFetch(url, requestOptions);
}

function createLabReportPDF(procedureId, resCb) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/createlabreportpdf?procedureId=${procedureId}`;
  return apiFetch(url, requestOptions);
}

function logInCheck(username, password) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/logincheck?username=${username}&password=${password}`;
  return apiFetch(url, requestOptions);
}

function updateValidator(data, username, id) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/updateValidator?id=${id}&username=${username}`;
  return apiFetch(url, requestOptions);
}

// -------------------- Export --------------------
const labService = {
  logout,
  handleResponse,
  getPackageTestnames,
  getTestnames,
  getCategoryByTemplateId,
  getFooterByTestName,
  updateApprover,
  getPackageList,
  createLabPackage,
  updatePackage,
  getAllTestsInfo,
  updatePackageStatus,
  createLabReportPDF,
  logInCheck,
  updateValidator,
};

export default labService;
